var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderHotkeys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 338,
    height: 111,
    viewBox: "0 0 338 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 45.561,
    height: 16.496,
    rx: 3.928
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "183.4%",
    height: "330.4%",
    x: "-41.7%",
    y: "-103.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 45.561,
    height: 16.496,
    rx: 3.928
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "183.4%",
    height: "330.4%",
    x: "-41.7%",
    y: "-103.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "f",
    width: 45.561,
    height: 16.496,
    rx: 3.928
  }), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "183.4%",
    height: "330.4%",
    x: "-41.7%",
    y: "-103.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#D8D8D8",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 12.569,
    fontWeight: "bold",
    letterSpacing: 0.483,
    transform: "translate(0 8.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13.375
  }, "Ball Called")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.439 9.445)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.561,
    height: 9.427,
    y: 8.641,
    fill: "#F1F1F1",
    rx: 3.928
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#414141",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 10.212,
    letterSpacing: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.499,
    y: 11.571
  }, "Key")), /*#__PURE__*/React.createElement("text", {
    fill: "#414141",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 10.212,
    fontWeight: "bold",
    letterSpacing: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.97,
    y: 11.571
  }, "C"))), /*#__PURE__*/React.createElement("text", {
    fill: "#D8D8D8",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 12.569,
    fontWeight: "bold",
    letterSpacing: 0.483,
    transform: "translate(0 44.205)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13.375
  }, "Ball Intentional")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.439 44.794)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.561,
    height: 9.427,
    y: 8.641,
    fill: "#F1F1F1",
    rx: 3.928
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#414141",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 10.212,
    letterSpacing: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.499,
    y: 11.571
  }, "Key")), /*#__PURE__*/React.createElement("text", {
    fill: "#414141",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 10.212,
    fontWeight: "bold",
    letterSpacing: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32.79,
    y: 11.571
  }, "I"))), /*#__PURE__*/React.createElement("text", {
    fill: "#D8D8D8",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 12.569,
    fontWeight: "bold",
    letterSpacing: 0.483,
    transform: "translate(0 79.554)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13.375
  }, "Strike Called")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.439 80.143)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.561,
    height: 9.427,
    y: 8.641,
    fill: "#F1F1F1",
    rx: 3.928
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#414141",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 10.212,
    letterSpacing: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.499,
    y: 11.571
  }, "Key")), /*#__PURE__*/React.createElement("text", {
    fill: "#414141",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 10.212,
    fontWeight: "bold",
    letterSpacing: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31.654,
    y: 11.571
  }, "S"))), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 10.212,
    letterSpacing: 0.393,
    transform: "translate(0 -14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 195.143,
    y: 34.23
  }, "Recommended")), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M.786 35.367H326v1H.786zM.786 70.717H326v1H.786zM.786 106.066H326v1H.786zM.786 1H326v1H.786z",
    opacity: 0.244
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.602 -13.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.326,
    height: 18.853,
    y: 22.357,
    fill: "#D8D8D8",
    rx: 3.928
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9.427,
    fontWeight: "bold",
    letterSpacing: 0.363
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.427,
    y: 35.481
  }, "Recommended"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderHotkeys);
export default __webpack_public_path__ + "static/media/placeholder-hotkeys.8821ba201f6d23567853d444af1851d7.svg";
export { ForwardRef as ReactComponent };